(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('ReportsController', reportsController);

  /** @ngInject */
  function reportsController(
    $scope,
    $state,
    ReportViewModel,
    ReportTypeEnum,
    deviceActions,
    layoutActions,
    dailyFinancesActions,
    sessionData
  ) {
    var vm = this;
    vm.fromDateMax;
    vm.reportTypes = getReportTypes();

    vm.report = new ReportViewModel(
      vm.reportTypes.find(function (reportType) {
        return reportType.state === $state.current.name;
      })
    );

    vm.toDateSelected = function () {
      vm.fromDateMax = vm.report.toDate;
    };

    init();

    function init() {
      layoutActions.showLoader();
      $scope.$on('$destroy', destroy);
      deviceActions.getAllDevices().then(function (data) {
        layoutActions.hideLoader();
        vm.report.refresh(data);
      });

      dailyFinancesActions.getData().then(function (response) {
        localStorage.setItem(sessionData.Keys.CURRENCY, response.currency);
      });

      if ($state.current.name === 'app.reports') {
        $state.go('app.reports.dailyTotal');
      }
    }

    function destroy() {
      vm.report.destroy();
    }

    function getReportTypes() {
      var result = [];

      result.push({
        state: 'app.reports.dailyTotal',
        type: ReportTypeEnum.MONEY_BY_DATE_REPORT
      });
      result.push({
        state: 'app.reports.dailyCoinsTotal',
        type: ReportTypeEnum.COINS_BY_DATE_REPORT
      });
      result.push({
        state: 'app.reports.dailyR2WTotal',
        type: ReportTypeEnum.R2W_BY_DATE_REPORT
      });
      // result.push({
      //   state: 'app.reports.dailyEuroKeyTotal',
      //   type: ReportTypeEnum.EUROKEY_BY_DATE_REPORT
      // });
      result.push({
        state: 'app.reports.avgByHour',
        type: ReportTypeEnum.AVG_MONEY_BY_HOUR_REPORT
      });
      result.push({
        state: 'app.reports.avgByDay',
        type: ReportTypeEnum.AVG_MONEY_BY_DAY_OF_WEEK_REPORT
      });
      result.push({
        state: 'app.reports.avgByBox',
        type: ReportTypeEnum.AVG_MONEY_BY_BOX_REPORT
      });
      // result.push({
      //   state: 'app.reports.comparation',
      //   type: ReportTypeEnum.COMPARE_PERIODS_REPORT
      // });
      result.push({
        state: 'app.reports.totalUsers',
        type: ReportTypeEnum.TOTAL_USERS_BY_GROUP
      });
      result.push({
        state: 'app.reports.totalVisits',
        type: ReportTypeEnum.VISITS_COUNT_REPORT
      });
      result.push({
        state: 'app.reports.givenLoyalty',
        type: ReportTypeEnum.TOTAL_SPENT_LOCAL_TOKENS_PER_DAY
      });
      result.push({
        state: 'app.reports.getTotalPurchasedLocalTokensPerDay',
        type: ReportTypeEnum.TOTAL_PURCHASED_LOCAL_TOKENS_PER_DAY
      });
      result.push({
        state: 'app.reports.getTotalGivenLocalTokensPerDay',
        type: ReportTypeEnum.TOTAL_GIVEN_LOCAL_TOKENS_PER_DAY
      });
      result.push({
        state: 'app.reports.changerIncome',
        type: ReportTypeEnum.CHANGER_INCOME
      });
      result.push({
        state: 'app.reports.posIncome',
        type: ReportTypeEnum.POS_INCOME
      });

      return result;
    }
  }
})();
